var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 116,
    viewBox: "0 0 274 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.48 0.599976C268.82 0.599976 273.96 5.73975 273.96 12.08C273.96 18.4202 268.82 23.56 262.48 23.56H196.88C203.22 23.56 208.36 28.6997 208.36 35.04C208.36 41.3802 203.22 46.52 196.88 46.52H232.96C239.3 46.52 244.44 51.6597 244.44 58C244.44 64.3402 239.3 69.48 232.96 69.48H216.275C208.281 69.48 201.8 74.6197 201.8 80.96C201.8 85.1868 205.08 89.0135 211.64 92.44C217.98 92.44 223.12 97.5797 223.12 103.92C223.12 110.26 217.98 115.4 211.64 115.4H75.5201C69.1798 115.4 64.0401 110.26 64.0401 103.92C64.0401 97.5797 69.1798 92.44 75.5201 92.44H11.5601C5.21985 92.44 0.0800781 87.3002 0.0800781 80.96C0.0800781 74.6197 5.21985 69.48 11.5601 69.48H77.1601C83.5003 69.48 88.6401 64.3402 88.6401 58C88.6401 51.6597 83.5003 46.52 77.1601 46.52H36.1601C29.8198 46.52 24.6801 41.3802 24.6801 35.04C24.6801 28.6997 29.8198 23.56 36.1601 23.56H101.76C95.4198 23.56 90.2801 18.4202 90.2801 12.08C90.2801 5.73975 95.4198 0.599976 101.76 0.599976H262.48ZM262.48 46.52C268.82 46.52 273.96 51.6597 273.96 58C273.96 64.3402 268.82 69.48 262.48 69.48C256.14 69.48 251 64.3402 251 58C251 51.6597 256.14 46.52 262.48 46.52Z",
    fill: "url(#paint0_linear_3032_13960)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3032_13960",
    x1: 139.557,
    y1: 115.422,
    x2: 139.537,
    y2: 0.574259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0EEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5001,
    stopColor: "#E9E8FD",
    stopOpacity: 0.5001
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDCF9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundNotFound);
export default __webpack_public_path__ + "static/media/background-not-found.596720187f16c514a5322ac49b9de7e0.svg";
export { ForwardRef as ReactComponent };